import React from "react";
import { useTranslation } from "react-i18next";
import { AuroraBackground } from "@/components/AuroraBackground";
import { LocaleLink } from "@/components/LocaleLink";
import { AppleBadge, GoogleBadge, StartFreeButton } from "@/components/StoreBadges";

const StoreAvailabilityPage = () => {
  const { t } = useTranslation(["site", "landing"]);
  const title = t(
    "site:storeAvailability.title",
    "Aurora is live on App Store & Google Play",
  );
  const body = t(
    "site:storeAvailability.body",
    "Download Aurora from your preferred store, or start instantly on the web.",
  );

  return (
    <section className="relative min-h-[76vh] pb-20">
      <AuroraBackground variant="hero" />
      <div className="relative mx-auto max-w-3xl px-5 lg:px-8 pt-12">
        <div
          className="rounded-[30px] border border-white/15 p-8 md:p-10"
          style={{
            background:
              "linear-gradient(145deg, rgba(21,8,48,0.92), rgba(14,5,36,0.94))",
            boxShadow:
              "0 30px 80px rgba(0,0,0,0.45), 0 0 0 1px rgba(243,195,90,0.16) inset",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
          }}
        >
          <p className="eyebrow text-[var(--aurora-gold)]">
            {t("site:storeAvailability.kicker", "Store launch update")}
          </p>
          <h1 className="mt-3 font-serif text-4xl leading-tight font-light text-white sm:text-5xl">
            {title}
          </h1>
          <p className="mt-5 text-base leading-relaxed text-white/78 sm:text-lg">
            {body}
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <StartFreeButton
              label={t("site:common.startFree", "Start Free Now")}
              testId="store-availability-start-free"
            />
            <AppleBadge testId="store-availability-apple" />
            <GoogleBadge testId="store-availability-google" />
            <LocaleLink to="/" className="btn-ghost">
              {t("site:storeAvailability.backHome", "Back to Home")}
            </LocaleLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoreAvailabilityPage;
